export default "__VITE_ASSET__CkyB1MTj__"